<template>
  <div>
    <ion-img class="img" src="/assets/image/mic_03s.gif"></ion-img>
  </div>
</template>

<script>
import {IonImg} from "@ionic/vue";

export default {
  name: "TestMicStop",
  components: {
    IonImg
  }
}
</script>

<style scoped>

</style>